<script setup lang="ts">
import { useAppStore } from '@/stores/app.store.ts'
import { computed } from 'vue'
import type { Stock } from '@/types/model'
import LabelBase from '@/components/label/LabelBase.vue'
import PhIcon from '@/components/PhIcon.vue'
import { useRouter } from 'vue-router'

// router & route
const router = useRouter()

// stores
const appStore = useAppStore()

// computed
const stock = computed<Stock | null>(() => appStore.pinnedStock)
</script>

<template>
  <div
    v-if="stock && stock.id && stock.id > 0"
    @click="router.push({ name: 'stock-edit', params: { id: stock.id } })"
    class="flex gap-4 mt-1 px-4 py-2 bg-stone-100 dark:bg-stone-900 rounded-xl cursor-pointer transition-colors duration-150"
  >
    <div class="self-center text-red-500">
      <ph-icon name="push-pin" :size="18"></ph-icon>
    </div>
    <div>
      <label-base size="sm" class="block font-mono font-bold whitespace-nowrap">{{
        stock.name
      }}</label-base>
      <label-base v-if="stock.ref" size="sm" class="block font-mono whitespace-nowrap">{{
        stock.ref
      }}</label-base>
    </div>
  </div>
</template>

<style scoped></style>
